import ApplicationsProvider from "../../contexts/ApplicationsContext";
import ContestsProvider from "../../contexts/ContestsContext";
import Error from "../../components/core/Error";
import GroupsProvider from "../../contexts/GroupsContext";
import Loading from "../../components/core/Loading";
import PageContainer from "../../components/layout/PageContainer";
import ParticipantsProvider from "../../contexts/ParticipantsContext";
import SignIn from "../../features/SignIn";
import ThankYouPage from "../ThankYouPage";
import UserDataLoader from "../../components/core/UserDataLoader";
import UserProvider from "../../contexts/UserContext";
import { app } from "../../App";
import { ContestWithId } from "../../interfaces/IContests";
import { getAuth, signOut } from "firebase/auth";
import { hasRegistrationAccess } from "../../utils/roleUtils";
import { Outlet } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { useContests } from "../../hooks/useContests";
import { useUser } from "../../hooks/useUser";

export default function Root() {
  const [loggedUserAuth, loading, error] = useAuthState(getAuth(app));
  const { user, isLoading: userLoading } = useUser(loggedUserAuth?.uid as string);
  // BEZPIECZEŃSTWO: useContests() wywołuje onSnapshot, który wymaga request.auth != null
  // Musi być wywoływane dopiero po sprawdzeniu czy użytkownik jest zalogowany
  const { contests = [] as ContestWithId[] } = useContests();

  if (loading) {
    return <Loading />;
  }
  if (error) {
    return <Error text={error.message} />;
  }
  if (!loggedUserAuth) {
    return <SignIn />;
  }

  {
    /* WYKOMENTOWANIE AKTYWACJI EMAIL - ZAŁĄCZONE DLA TESTÓW */
  }

  // Jeśli użytkownik jest zalogowany, ale nie zweryfikował adresu email – pokaż stronę aktywacji
  // if (loggedUserAuth && !loggedUserAuth.emailVerified) {
  //   return <ThankYouPage />;
  // }

  // Pokaż loading podczas ładowania danych użytkownika (tylko gdy jest zalogowany)
  // Ten warunek jest potrzebny, aby uniknąć migania starych danych podczas przełączania użytkowników.
  // Musi on być niezależny od sprawdzaniu stanu loading z auth, aby nie zablokować się na ekranie spinnera ładowania.
  if (userLoading || !user) {
    return <Loading />;
  }

  // NOWA WERYFIKACJA RÓL
  const hasAccess = hasRegistrationAccess(user);
  
  if (!hasAccess) {
    // Renderuj komunikat bez PageContainer (bez drawer/menu)
    return (
      <div style={{ 
        display: "flex", 
        justifyContent: "center", 
        alignItems: "center", 
        minHeight: "100vh",
        backgroundColor: "background.default"
      }}>
        <div style={{ textAlign: "center", padding: "2rem", maxWidth: "500px" }}>
          <h2>Brak uprawnień</h2>
          <p>Nie masz uprawnień do aplikacji.</p>
          <p>Skontaktuj się z administratorem systemu.</p>
          <button 
            onClick={() => signOut(getAuth(app))}
            style={{ 
              marginTop: "1rem", 
              padding: "0.5rem 1rem", 
              cursor: "pointer",
              fontSize: "1rem"
            }}
          >
            Wyloguj
          </button>
        </div>
      </div>
    );
  }

  return (
    <UserProvider key={user.id} userId={user.id}>
      {contests && (
        <ContestsProvider contests={contests}>
          <ApplicationsProvider userId={user.id}>
            <ParticipantsProvider userId={user.id}>
              <GroupsProvider userId={user.id}>
                <UserDataLoader>
                  <PageContainer>
                    <Outlet />
                  </PageContainer>
                </UserDataLoader>
              </GroupsProvider>
            </ParticipantsProvider>
          </ApplicationsProvider>
        </ContestsProvider>
      )}
    </UserProvider>
  );
}
